import * as fromCompare from '../actions/compare.action';

export interface CompareState {
  compare: any;
  loading: boolean;
  loaded: boolean;
}

export const initialState: CompareState = {
  compare: {} as any,
  loading: false,
  loaded: false,
};

export function reducer(state = initialState, action: fromCompare.CompareActions): CompareState {
  switch (action.type) {
    case fromCompare.COMPARE_VERSIONS: {
      return {
        ...state,
        loading: true,
      };
    }

    case fromCompare.COMPARE_VERSIONS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case fromCompare.COMPARE_VERSIONS_SUCCESS: {
      const payload = action.payload;

      return {
        ...state,
        compare: payload,
        loading: false,
        loaded: true,
      };
    }
    case fromCompare.CLEAR_COMPARE: {
      return {
        ...state,
        compare: {},
        loading: false,
        loaded: false,
      };
    }
  }

  return state;
}

export const getCompare = (state: CompareState) => state.compare;
export const getCompareLoading = (state: CompareState) => state.loading;
export const getCompareLoaded = (state: CompareState) => state.loaded;
